import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import AiconConfigPage from "@/pages/aicon-config-page";
import ServiceConfigPage from "@/pages/service-config-page";

export const Route = createFileRoute(
  "/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name"
)({
  component: Component,
});

function Component() {
  const { "config-name": configName } = Route.useParams();
  return <AiconConfigPage config={configName} />;
}
